"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var DecodeError_1 = require("../errors/DecodeError");
var RandomUtil_1 = require("../util/RandomUtil");
var SessionTag = (function () {
    function SessionTag() {
        this.tag = new Uint8Array([]);
    }
    SessionTag.new = function () {
        var length = 16;
        var st = ClassUtil_1.default.new_instance(SessionTag);
        st.tag = RandomUtil_1.default.random_bytes(length);
        return st;
    };
    SessionTag.prototype.toString = function () {
        return sodium.to_hex(this.tag);
    };
    SessionTag.prototype.encode = function (encoder) {
        return encoder.bytes(this.tag);
    };
    SessionTag.decode = function (decoder) {
        var length = 16;
        var bytes = new Uint8Array(decoder.bytes());
        if (bytes.byteLength !== length) {
            throw DecodeError_1.default.InvalidArrayLen("Session tag should be 16 bytes, not " + bytes.byteLength + " bytes.", DecodeError_1.default.CODE.CASE_303);
        }
        var st = ClassUtil_1.default.new_instance(SessionTag);
        st.tag = new Uint8Array(bytes);
        return st;
    };
    return SessionTag;
}());
exports.default = SessionTag;
//# sourceMappingURL=SessionTag.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/message/SessionTag.js
// module id = 42
// module chunks = 0 1